import { messages as portugueseMessages } from './ptBR'
import { messages as englishMessages } from './en'
import { messages as spanishMessages } from './es'

export const messages = {
    ...portugueseMessages,
    ...englishMessages,
    ...spanishMessages
}